﻿<div class="dialog-container">
    <button mat-icon-button class="close-button" [mat-dialog-close]="true" [disableRipple]="true">
        <mat-icon>close</mat-icon>
    </button>
    <div class="dialog-icon">
        <span class="material-icons">help</span>
    </div>
    <h2 class="dialog-title">{{ data.title }}</h2>
    <div class="dialog-content">
        <p>{{ data.message }}</p>
    </div>
    <div class="dialog-actions">
        <button mat-raised-button class="yes-button" (click)="onYes()">Yes</button>
        <button mat-raised-button class="no-button" (click)="onNo()" mat-dialog-close>No</button>
    </div>
</div>